<template>
  <div>
    <router-view v-if="$route.name === 'UpdateRecord'" />
    <div
      v-else
      class="table-box">
      <div class="table-top">
        <div class="left">
          <el-select
            v-model="subjectValue"
            :clearable="true"
            class="position-left"
            @change="querySubject"
            @clear="clearSubjectValue"
          >
            <el-option
              v-for="subject in subjects"
              :key="subject.id"
              :label="subject.name"
              :value="subject.id"
            />
          </el-select>

          <el-cascader
            v-model="structureValue"
            :clearable="true"
            :options="structure"
            :props="structureProps"
            class="position-left"
            placeholder="请选择学科以及对应课时"
            @change="queryStructure"
          />
          <el-input
            v-model="classTitle"
            :clearable="true"
            class="position-left input-name"
            type="text"
            placeholder="课时名称"
            @focus="focus"
            @blur="blur"
          />
          <el-select
            v-model="updateState"
            :clearable="true"
            class="position-left"
            placeholder="更新状态"
            @focus="focus"
            @blur="blur"
          >
            <el-option
              v-for="item in updateStateData"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
          <el-select
            v-model="completeState"
            :clearable="true"
            class="position-left"
            placeholder="完成状态"
            @focus="focus"
            @blur="blur"
          >
            <el-option
              v-for="item in completeStateData"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
          <el-date-picker
            v-model="time"
            :picker-options="pickerOptions"
            class="position-left date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"/>
          <el-button
            class="btn"
            icon="el-icon-search"
            circle
            @click="handleSearch"
          />
        </div>
        <div class="right">
          <el-button
            class="btn"
            round
            @click="handleUpdateRecord"
          >更新记录</el-button>
          <el-button
            class="btn"
            round
            @click="handleSetUpdate"
          >提交更新</el-button>
          <el-button
            class="btn"
            round
            @click="handleClickAdd"
          >创建课时</el-button>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          fixed
        />
        <template v-for="(item,index) in propsData">

          <el-table-column
            v-if="item.attr === 'updateState'"
            :key="index"
            :prop="item.attr"
            :label="item.name"
            :width="item.columnWidth">
            <template slot-scope="scope">
              <StateBox :value="scope.row.updateState"/>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            :prop="item.attr"
            :label="item.name"
            :width="item.columnWidth"
          />
        </template>
        <el-table-column
          fixed="right"
          label="操作"
          width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleClick(scope.row)">查看</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleClickHighEdit(scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleSeeClass(scope.row)"
            >预览</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleSetUpdate(scope.row)"
            >更新</el-button>

            <el-dropdown
              trigger="hover"
              @command="handleMore"
              @visible-change="getRow(scope.row)">
              <el-button
                type="text"
                size="small"
              >&nbsp;&nbsp;更多</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  command="share"
                  class="clearfix">
                  分享
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="$store.getters.getPermissions.course_copy"
                  command="fuzhi"
                  class="clearfix">
                  复制
                </el-dropdown-item>
                <el-dropdown-item
                  command="edit"
                  class="clearfix">
                  课时编辑
                </el-dropdown-item>
                <el-dropdown-item
                  command="beike"
                  class="clearfix">
                  备课内容
                </el-dropdown-item>
                <el-dropdown-item
                  command="yuxi"
                  class="clearfix">
                  预习编辑
                </el-dropdown-item>
                <el-dropdown-item
                  command="fuxi"
                  class="clearfix">
                  复习编辑
                </el-dropdown-item>
                <el-dropdown-item
                  command="clean"
                  class="clearfix">
                  清缓存
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-box">
        <el-pagination
          :current-page="currentPage"
          :page-size="10"
          :total="pageTotal"
          class="app-pagination"
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"/>
      </div>

      <el-dialog
        :visible.sync="isShare"
        :before-close="()=>{isShare = false}"
        title="课件分享"
        width="800px">
        <Share
          v-if="isShare"
          ref="shareForm"
          :row="shareRow"
          @onCancel="isShare=false" />
      </el-dialog>

      <el-dialog
        :visible.sync="isDetail"
        :before-close="()=>{isDetail = false}"
        class="detail-dialog"
        title="课中详情"
        width="1000px">
        <Detail
          v-if="isDetail"
          ref="detail"
          :form="detailData"
          @onCancel="isDetail=false" />
      </el-dialog>
      <CourseEditor
        ref="edit"
        :visible.sync="editor.visible"
        :data="editor.data"
        @success="onEditor"
      />

      <CourseCopy
        :visible.sync="copy.visible"
        :data="copy.data"
        @success="onCopy"
      />

      <el-dialog
        :visible="visible.preview"
        :show-close="false"
        top="5vh"
        width="1000px"
        title="预习编辑">
        <DetailPreview
          v-if="visible.preview"
          :id="shareRow.id"
          @success="previewUpdate"
          @cancel="previewCancel"
        />
      </el-dialog>
      <el-dialog
        :visible="visible.review"
        :show-close="false"
        width="1000px"
        top="5vh"
        title="复习编辑">
        <DetailReview
          v-if="visible.review"
          :id="shareRow.id"
          @success="reviewUpdate"
          @cancel="reviewCancel"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import mapUtils, { $list, $http } from "@/utils";
import store from "@/store";
import { mapState } from "vuex";
import { Message } from "element-ui";
import { parseTime, stringSize, jsonToEqualString } from "../../utils/common";
import * as CourseListServer from "../../api/courseList";
import Share from "./components/Share.vue";
import Detail from "./detail.vue";
import fields from "./fields";
import CourseEditor from "../Course/components/CourseListEditor.vue";
import UpdateRecord from "./updateRecord/updateRecord.vue";
import StateBox from "./components/StateBox.vue";
import Config from "../../config/app";
import DetailReview from "../Course/components/DetailReview.vue";
import DetailPreview from "../Course/components/DetailPreview.vue";
import CourseCopy from "../Course/components/CourseCopy.vue";

  export default {
    name: "CourseList",
    components: {
      Share,
      Detail,
      CourseEditor,
      UpdateRecord,
      StateBox,
      DetailReview,
      DetailPreview,
      CourseCopy,
    },
    data() {
      return {
        subjectValue: null,
        structureValue: null,

        structureProps: {
          children: "leaf",
          value: "id",
          label: "name",
        },

        focusState: false, // 是否查询焦点
        loading: false, // 加载
        shareRow: "", // 分享行
        selectedRows: null, // 表格已勾选行数据
        propsData: fields,
        tableData: [],
        className: "", // 课时名称
        classTitle: "", // 课时标题
        classNameData: [], // 学科列表
        updateState: "",
        updateStateData: [
          // {
          //   label: "待更新",
          //   value: 1,
          // },
          {
            label: "正在更新",
            value: 2,
          },
          {
            label: "已更新",
            value: 3,
          },
        ],
        completeState: "",
        completeStateData: [
          {
            label: "已完成",
            value: 2,
          },
          {
            label: "未完成",
            value: 1,
          },
        ],
        time: "", // 时间区间
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 7));
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 30));
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 90));
              picker.$emit("pick", [start, end]);
            },
          }],
        },

        isShare: false, // 分享弹出
        isDetail: false, // 详情弹出
        detailData: [
          // { type: "title", label: "课中详情查看", isFirst: true },
          // [
          //   { type: "text", label: "课时名称", value: "XXX" },
          //   { type: "text", label: "课时标题", value: "XXX" },
          //   { type: "text", label: "所属单元", value: "XXX" },
          // ],
          // { type: "text", label: "教学知识点", value: "XXX" },
          // { type: "text", label: "内容介绍", value: "XXX" },
          // [
          //   { type: "text", label: "课时创建时间", value: "XXX" },
          //   { type: "text", label: "课中完成状态", value: "已完成" },
          //   { type: "text", label: "课中更新状态", value: "更新成功" },
          // ],
          // { type: "text", label: "课中更新时间", value: "XXX" },
          // { type: "title", label: "课中更新记录" },
          // { type: "table", value: [["已更新", "2019-09-17", "retro", "retro"]], thead: ["状态", "操作时间", "操作人", "操作账号"] },
        ], // 详情内容

        // 编辑
        editor: {
          data: null,

          visible: false,
        },
        // 复制
        copy: {
          data: null,

          visible: false,
        },
        // 更新状态枚举
        updateStateEnum: ["", "准备开始", "正在更新", "更新完成"],
        // 打包更新处理状态：0=失败; 1=待更新；2=更新中；3=已更新
        backUpdateEnum: ["", "准备打包", "打包中", "打包完成", "打包成功", "打包失败", ...new Array(93), "放弃打包"],
        // 分页参数
        currentPage: 1, // 当前页
        per_page: 10,
        pageTotal: 0,

        // 预习复习
        visible: {
          review: false,
          preview: false,
        },
      };
    },

    computed: {
      ...mapState("course", ["subjects", "structure", "themes"]),

      // subjectValue() {
      //   return Number(this.$route.query.subject);
      // },
      //
      // structureValue() {
      //   return this.$route.query.structure.split(",").map(id => Number(id));
      // },
    },
    created() {
      this.themes.length || this.$store.dispatch("course/initThemes");
      this.init();
    },
    methods: {
      // 清空学科结构
      clearSubjectValue() {
        this.subjectValue = null;
        this.structureValue = null;
      },
      async init() {
        this.getSubjectList();
        this.flashTable();

        const self = this;
        // 监听回车 查询
        document.onkeydown = function (event) {
          const e = event || window.event;
          if (e && e.keyCode === 13) { // 回车键的键值为13
            if (self.focusState) self.handleSearch();
          }
        };
      },
      // 回车查询
      focus() {
        this.focusState = true;
      },
      blur() {
        this.focusState = false;
      },
      // 查询
      handleSearch() {
        this.currentPage = 1;
        this.flashTable();
      },
      // 获取表格数据并更新
      async flashTable() {
        const res = await this.getDataByParams();
        res && this.updateTable(res);
      },
      // 更新记录
      handleUpdateRecord() {
        console.log("更新记录==>", this.selectedRows);
        this.$router.push("/courseList/list/record");
      },
      // 提交更新
      async handleSetUpdate(e) {
        let state = false;
        if (Object.prototype.toString.call(e) === "[object Object]") {
          // TODO 单行更新
          console.log("单行更新==>", e);
          if (e.complete === "未完成") state = true;
          if (state) {
            Message.error("存在“未完成”的状态，不允许提交更新");
            return false;
          }
          await CourseListServer.setUpdateSend({ course_id: e.id });
          Message.success("更新成功");
          this.flashTable();
        } else {
          // TODO 批量更新
          console.log("批量更新==>", this.selectedRows);
          if (!this.selectedRows) {
            Message.error("请选择您要提交的更新项");
            return false;
          }
            this.selectedRows.map((v) => {
              if (v.complete === "未完成") state = true;
            });
            if (state) {
              Message.error("存在“未完成”的状态，不允许提交更新");
              return false;
            }

          await CourseListServer.setUpdateSend({ course_id: this.selectedRows.map(v => v.id) });
          Message.success("批量更新成功");
          this.flashTable();
        }
      },
      // 获取学科列表
      async getSubjectList() {
        const res = await CourseListServer.querySubject_List();
        this.classNameData = res.data.map(v => ({
            label: v.name,
            value: v.id,
          }));
      },
      // 请求列表接口
      async getDataByParams(params = {}) {
        this.loading = true;
        const {
          subject_id = this.subjectValue, // 学科
          structure_id = this.structureValue, // 课程名称
          page = this.currentPage, // 当前页
          per_page = this.per_page, // 每页容量
          name = this.classTitle, // 课时名称
          pack_status = this.updateState, // 更新状态
          complete = this.completeState, // 更新状态
          created_start = this.time && this.time[0], // 开始时间
          created_end = this.time && this.time[1], // 结束时间
        } = params;
        const obj = {
          page, per_page,
        };
        if (subject_id)obj["equal[subject_id]"] = subject_id;
        if (structure_id)obj["equal[structure_id]"] = JSON.parse(JSON.stringify(structure_id)).pop();
        if (name)obj["like[name]"] = name;
        if (pack_status)obj["equal[pack_status]"] = pack_status;
        if (complete)obj["equal[courseware_status]"] = complete;
        if (created_start)obj.search_updated_at_start = parseTime(created_start);
        if (created_end)obj.search_updated_at_end = parseTime(created_end);

        console.log("retro==>1011", obj);
        const res = await CourseListServer.queryCourseList(obj);

        this.loading = false;
        return res;
      },
      // 更新表格数据
      updateTable(res) {
        this.tableData = res.data.map(v => ({
            ...v,
            id: v.id,
            structure_id: v.structure_id,
            theme_id: v.theme_id,
            name: v.name,
            title: stringSize(v.title, 25) || '--',
            title_real: v.title || '--',
            unit: v.unit_name || '--',
            known: stringSize(v.knowledge_content, 25) || '--',
            known_real: v.knowledge_content || '--',
            content: stringSize(v.description, 25) || '--',
            content_real: v.description || '--',
            createTime: v.created_at || '--',
            complete: v.courseware_status_name || '--',
            updateTime: v.packet_updated_at || '--',
            updateState: this.updateStateEnum[v.pack_status] || '--',
          }));
        this.pageTotal = res.total;
      },
      // 创建成功回调
      onEditor(e) {
        console.log("success==>", e);
        this.editor.data = null;
        this.flashTable();
      },
      // 复制功回调
      onCopy(e) {
        console.log("success==>", e);
        this.copy.data = null;
        this.flashTable();
      },
      // 创建课时
      handleClickAdd() {
        this.$refs.edit && this.$refs.edit.clearAll();
        this.editor.visible = true;
        this.editor.data = null;
      },
      // 编辑课时
      handleClickEdit(row) {
        // this.courseData = {
        //   created_at: row.created_at,
        //   description: row.description,
        //   id: row.id,
        //   image: row.image,
        //   knowledge_content: row.knowledge_content,
        //   mini_image: row.mini_image,
        //   name: row.name,
        //   theme_id: row.theme_id,
        //   title: row.title,
        //   unit_id: row.unit_id,
        //   updated_at: row.updated_at,
        // };
        // this.classAdd = true;
        const { id } = row;
        const prepare = id ? $http.get(`/course/${id}`) : Promise.resolve(null);

        prepare
                .then((res) => {
                  this.editor.data = { ...row, ...res };
                })
                .then(() => {
                  this.editor.visible = true;
                });
      },
      // 课程预览
      handleSeeClass(row) {
        console.log("课程预览==>", row);
        this.$router.push(`/course_preview/${row.id}/${row.theme_id}`);
      },
      // 复制课程
      handleCopyCourse(row) {
        const { id } = row;
        const prepare = id ? $http.get(`/course/${id}`) : Promise.resolve(null);

        prepare
          .then((res) => {
            this.copy.data = { ...row, ...res };
          })
          .then((res) => {
            this.copy.visible = true;
          });
      },
      async handleClick(row) {
        this.isDetail = true;
        console.log(row);
        // 更新详情页
        this.detailData = [
          // { type: "title", label: "课中详情查看", isFirst: true },
          [
            { type: "text", label: "课时名称", value: row.name },
            { type: "text", label: "课时标题", value: row.title_real },
            { type: "text", label: "所属单元", value: row.unit },
          ],
          { type: "text", label: "教学知识点", value: row.known_real },
          { type: "text", label: "内容介绍", value: row.content_real },
          [
            { type: "text", label: "课时创建时间", value: row.createTime },
            { type: "text", label: "课中完成状态", value: row.complete },
            { type: "text", label: "课中更新状态", value: row.updateState },
          ],
          { type: "text", label: "课中更新时间", value: row.updateTime },
          { type: "title", label: "课中更新记录" },
          // { type: "table", value: [["已更新", "2019-09-17", "retro", "retro"]], thead: ["状态", "操作时间", "操作人", "操作账号"] },
        ];

        // 请求更新记录
        const res = await CourseListServer.queryUpdateRecordOne({ course_id: row.id });
        const data = [];
        res.data.map((v) => {
          data.push([
            this.backUpdateEnum[v.status], v.created_at, v.admin && v.admin.realname, v.admin && v.admin.name,
          ]);
        });
        // debugger
        if (res && res.data) {
          this.detailData = this.detailData.concat([
            {
              type: "table",
              thead: ["状态", "操作时间", "操作人", "操作账号"],
              value: data,
            },
          ]);
        }
      },
      // 跳转高级编辑
      handleClickHighEdit(row) {
        console.log("row-data==>", row);
        const param = {
          id: row.id,
          pattern: "edit",
          name: row.name,
          title: row.title,
          dev: Config.web_url === "https://course-editor-look.aikaola.com" ? "formal" : "test",
          courseware_status: row.courseware_status,
          theme_id: row.theme_id,
          themeValue: row.theme_name,
          token: Config.token,
        };
        const paramString = jsonToEqualString(param);
        window.open(`${Config.web_url}/Editor/index.html?${paramString}`,
        );
      },
      // 课时名称选中
      handleChangeClassName(e) {
        console.log("课时名称选中==>", e);
      },
      handleSizeChange(e) {
        console.log("handleSizeChange==>", e);
      },
      handleCurrentChange(e) {
        console.log("handleCurrentChange==>", e);
        // 翻页更新
        this.currentPage = e;
        this.flashTable();
      },
      // 获取选中的行id
      getRow(row) {
        console.log("retro==>clickRow", row);
        if (row.id) this.shareRow = row;
      },
      handleMore(e, node) {
        console.log("retro10111636==>", e, node);
        switch (e) {
          case "share":
            this.onClickMore();
            break;
          case "fuzhi":
            this.handleCopyCourse(this.shareRow);
            break;
          case "edit":
            this.handleClickEdit(this.shareRow);
            break;
          case "beike":
            console.log("备课==>");
            this.$router.push(`/course/assist?id=${this.shareRow.id}`);
            break;
          case "yuxi":
            console.log("预习==>");
            this.visible.preview = true;
            break;
          case "fuxi":
            console.log("复习==>");
            this.visible.review = true;
            break;
          case "clean":
            console.log("清缓存==>");
            this.clearCache();
            break;
        }
      },
      // 清除课程缓存
      async clearCache() {
        try {
          const res = await CourseListServer.clearCourseCache({ course_id: this.shareRow.id });
          if (res) {
            console.log("清除缓存结果==>", res);
            Message.success("清缓存成功");
          }
        } catch (e) {
          Message.error("清缓存失败", e);
        }
      },
      // 选中行数
      selectionChange(seleteds) {
        console.log("选中行数==>", seleteds);
        this.selectedRows = seleteds;
      },
      // 更多
      onClickMore() {
        console.log("更多==>分享", this.shareRow);
        this.isShare = true;
      },
      // 确认
      onSubmit() {
        this.$refs.shareForm.submitForm("shareForm");
      },

      querySubject(subject) {
        this.$store
                .dispatch("course/initStructure", Number(subject))
                .then((structure) => {
                  this.structureValue = null;
                  const query = {
                    ...this.query,
                    subject,
                    structure,
                    page: 1,
                  };

                  this.$list_routeQuery && this.$list_routeQuery(query);
                });
      },

      queryStructure() {
        // 如果学科结构有值，直接搜索
        if (this.subjectValue) {
          this.handleSearch();
        }
      },
      // 刷新
      previewUpdate() {
        this.flashTable();

        this.previewCancel();
      },

      previewCancel() {
        this.visible.preview = false;
      },

      reviewUpdate() {
        this.flashTable();

        this.reviewCancel();
      },

      reviewCancel() {
        this.visible.review = false;
      },
    },

  };
</script>

<style lang="postcss" scoped>
.table-box{
    padding: 40px;
    padding-top: 30px;
}

.table-top{
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.table-top .left{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.table-top .left .btn{
  margin-top: 10px;
}
.position-left{
    margin-right: 10px;
    width: 120px;
    margin-top: 10px;
}
.position-left.date{
    width: 400px;
}
.input-name{
    width: 200px;
}
.table-top .right{
    min-width: 304px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
}
.table-top .right .btn{
    margin-top: 10px;
}
.pagination-box{
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-content: center;
    padding: 10px 0px;
}
.sp-space{
  display: inline-block;
  width: 20px;
  height: 20px;
}
.detail-dialog >>> .el-dialog__body{
  padding-top: 0px;
}
.table-box >>> .el-dialog__header{
  border-bottom: 1px solid #f0f0f0;
}
</style>
